export const buildingList = [
  "empty",
  "townhall",
  "wall",
  "builderhut",
  "goldmine",
  "elixircollector",
  "goldstorage",
  "elixirstorage",
  "barracks",
  "armycamp",
  "cannon",
  "laboratory",
  "airdefense",
  "archertower",
  "mortar",
  "wallH",
  "wallV",
  "clancastle",
  "bomb",
  "spellfactory",
  "wizardtower",
  "springtrap",
  "xbow",
  "xbow:both",
  "giantbomb",
];
